import {useGetToken} from 'components/hooks';
import {collaboratorFiltered} from 'constants/url';
import CustomStore from 'devextreme/data/custom_store';
import authFetch from '../../../helpers/requests';
import useGetFilter from './useGetFilter';
import {useSelector} from 'react-redux';

function useLoadCollaboratorPUT(
  value: number,
  id_course: number,
  useFiltersGrid: boolean,
) {
  const filtersGrid = useSelector((state: any) => state.gridReducer.filters);
  const filters: any[] = useGetFilter();
  let filterSector = filters.filter((x) => x.columnName === 'iD_Sector');
  const result = filterSector.map((a) => a.value);
  let options = new URLSearchParams();
  if (useFiltersGrid) {
    options.append('filter', JSON.stringify(filtersGrid));
  }
  return useLoadCustomDataSource(
    `${collaboratorFiltered}${useFiltersGrid ? `?${options}` : ''}`,
    'employee_Nr',
    {
      id_instance: value,
      id_course: id_course,
      filters: result,
    },
  );
}

function useLoadCustomDataSource(
  url: string,
  key: string | string[],
  parameter: Object | undefined = undefined,
) {
  const token = useGetToken();
  const customDataSource = new CustomStore({
    key: key,
    load: async (loadOptions: any) => {
      let params = '?';

      [
        'filter',
        'group',
        'groupSummary',
        'parentIds',
        'requireGroupCount',
        'requireTotalCount',
        'searchExpr',
        'searchOperation',
        'searchValue',
        'select',
        'sort',
        'skip',
        'take',
        'totalSummary',
        'userData',
      ].forEach(function (i: any) {
        if (i in loadOptions && isNotEmpty(loadOptions[i])) {
          params += `${i}=${JSON.stringify(loadOptions[i])}&`;
        }
      });
      params = params.slice(0, -1);

      try {
        const response = await authFetch(
          `${url}${params}`,
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json; charset=utf-8',
            },
            body: JSON.stringify(JSON.stringify(parameter)),
          },
          token,
        );
        const response_1 = await handleErrors(response);
        const response_2 = await response_1.json();
        return {
          data: response_2.data,
          totalCount: response_2.totalCount,
          summary: response_2.summary,
          groupCount: response_2.groupCount,
        };
      } catch (e) {
        console.error('Error al cargar');
      }
    },
  });
  return customDataSource;
}

const isNotEmpty = (value: any) =>
  value !== undefined && value !== null && value !== '';

function handleErrors(response: any) {
  if (!response.ok) {
    throw Error(response.statusText);
  }
  return response;
}

export default useLoadCollaboratorPUT;
